module.exports = __webpack_public_path__ + "img/level_3.f8d3d97e.png";